<template>
  <div class="chapter_list">
    <h3 class="title">
      <span class="course_title">{{ classInfo.courseTitle }}</span>
      <!-- <span class="class_name">{{ classInfo.name }}</span> -->
    </h3>
    <el-tree
      :data="chapters"
      :props="{
        children: 'children',
        label: 'title',
      }"
      :default-expand-all="true"
      @node-click="handleChange"
    >
      <span
        class="custom-tree-node"
        :class="{
          'custom-chapter': !data.children,
        }"
        slot-scope="{ data }"
      >
        <span
          :class="{
            'active-chapter': activeId == data.classChapterId,
          }"
          >{{ data.title }}</span
        >

        <el-tag
          v-if="data.sz"
          style="margin-left: 10px"
          effect="dark"
          size="mini"
          >实训</el-tag
        >
        <el-tag
          v-if="data.mock"
          style="margin-left: 10px"
          effect="dark"
          type="warning"
          size="mini"
          >仿真实训</el-tag
        >
        <el-tag
          v-if="data.teamGrade"
          style="margin-left: 10px"
          effect="dark"
          type="success"
          size="mini"
          >评价</el-tag
        >
      </span>
    </el-tree>
  </div>
</template>

<script>
import { chapterList } from "@/api/chapter";
import { classInfo } from "@/api/class";
import { handleTree } from "@/utils";
export default {
  name: "chapterList",
  data() {
    return {
      activeId: 1,
      classInfo: {},
      chapters: [],
    };
  },
  created() {
    this.getClassInfo();
    this.getChapterList();
    this.activeId = this.$route.query.classChapterId || null;
  },
  watch: {
    $route(val) {
      this.activeId = val.query.classChapterId;
    },
  },
  methods: {
    // 班级信息
    getClassInfo() {
      classInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          this.chapters = handleTree(res.data, "chapterId");
        } else {
          console.log(res.msg);
        }
      });
    },
    handleChange(chapter) {
      if (chapter.children) return;
      if (chapter.disabled) {
        this.$message.warning("章节未开放,请联系管理员");
        return;
      }
      this.activeId = chapter.classChapterId;
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.classChapterId = chapter.classChapterId;
      query.chapterId = chapter.chapterId;
      query.chapterTitle = chapter.title;
      this.$router.push({
        path: this.$route.path,
        query,
      });
      this.$emit("update", true);
    },
  },
};
</script>

<style lang="less" scoped>
.chapter_list {
  padding: 20px;
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }

  .title {
    padding-bottom: 5px;
    font-size: 20px;
    color: #fff;
    line-height: 1.5;
    border-bottom: solid 1px #646464;

    .class_name {
      margin-left: 10px;
    }
  }

  ::v-deep .el-tree {
    margin: 5px 0;
    background-color: #444655;
    color: #fff;
    .el-tree-node {
      white-space: normal;
      .el-tree-node__content {
        height: inherit;
        min-height: 30px;
        background-color: #444655;
        &:hover {
          background-color: inherit;
        }
      }
    }
  }

  .custom-tree-node {
    &.custom-chapter {
      transition: all 0.3s ease;
      &:hover {
        color: teal;
      }
      .active-chapter {
        color: teal;
      }
    }
  }

  .catalog {
    padding-bottom: 5px;
    border-bottom: solid 1px #646464;
  }
  .catalog_title {
    padding: 8px 0;
    color: #fff;
    font-weight: bold;
  }
  .chapter_title {
    padding: 5px 0;
    color: #fff;
    text-indent: 2em;
    text-align: justify;
    cursor: pointer;
    transition: all 0.3s ease;

    .tag {
      margin-left: 5px;
      text-indent: 0;
    }
    &:hover,
    &.active_chapter {
      color: teal;
    }
  }
}
</style>